import { render } from "./OurCustomer.vue?vue&type=template&id=74e75301&scoped=true"
import script from "./OurCustomer.vue?vue&type=script&lang=js"
export * from "./OurCustomer.vue?vue&type=script&lang=js"

import "./OurCustomer.vue?vue&type=style&index=0&id=74e75301&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e75301"]])

export default __exports__